import React from "react";
import { SketchPicker } from 'react-color';

export default class ColorInput extends React.Component {

    constructor (props){
        super(props);

        this.state = {
            value: this.props.value,
            open: false
        }        
    }

    componentDidMount(){
        this.setState({
            value: this.props.value,
            open: false
        });
    }

    handleChangeComplete = (color) => {
        this.setState({ value: color.hex });
    };

    render (){

        return ( 
        <div style={mainClass}>
            <div style={{display: 'flex'}}>
                <div style={name}>{this.props.name}</div>
                <div style={{marginLeft: '10px', width: 25, height: 25, border: '1px solid black', background: this.state.value}} onClick={() => {                    
                if (this.state.open === true)
                    this.props.onChange(this.state.value);
                this.setState({open: !this.state.open});

                }}>
            </div>
            </div>
            <div style={{display: this.state.open === true ? 'block' : 'none'}}>
                <div style={{marginTop: '10px'}}>
                    <SketchPicker
                        color={ this.state.value }
                        onChangeComplete={ this.handleChangeComplete }
                    />
                </div>
            </div>
        </div>
        )
    }


}

const mainClass = {
    padding: '10px',
}

const name = {
    
}

const inputText = {
    width: '300px'
}